import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/sidebar";
import Header from "./gapsy-header";
import Navigation from "./gapsy-Cnavigation";
import * as XLSX from "xlsx";
import styles from "../assets/css/gapsy-dashboard.module.css";
import Footer from './gapsy-footer';
import tableStyles from '../assets/css/sharedTableStyles.module.css';


function GapsyTableauReport() {
    const navigate = useNavigate();

    const [excelData, setExcelData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [tooltip, setTooltip] = useState({
        show: false,
        x: 0,
        y: 0,
        data: null
    });
    const [selectedCriticality, setSelectedCriticality] = useState([]);
    const [selectedFrequency, setSelectedFrequency] = useState([]);
    const [selectedRiskArea, setSelectedRiskArea] = useState([]);
    const [selectedDates, setSelectedDates] = useState([]);

    const formatExcelDate = (excelDate) => {
        if (!excelDate) return "";

        const jsDate = new Date((excelDate - 25569) * 86400 * 1000);
        return jsDate.toLocaleDateString("en-GB"); // DD/MM/YYYY
    };

    /* ------------------ LOAD EXCEL ------------------ */
    useEffect(() => {
        const fetchExcel = async () => {
            const response = await fetch("/jsonfiles/tableaureportdata.xlsx");
            const data = await response.arrayBuffer();
            const workbook = XLSX.read(data, { type: "array" });
            const sheet = workbook.Sheets[workbook.SheetNames[0]];
            const jsonData = XLSX.utils.sheet_to_json(sheet);
            setExcelData(jsonData);
            setFilteredData(jsonData);
        };

        fetchExcel();
    }, []);

    /* ------------------ FILTER LOGIC ------------------ */
    useEffect(() => {
        if (
    selectedCriticality === null ||
    selectedFrequency === null ||
    selectedRiskArea === null ||
    selectedDates === null
) {
    setFilteredData([]);
    return;
}

const result = excelData.filter((item) => {
    return (
        (selectedCriticality.length === 0 ||
         selectedCriticality.includes(item.Criticality)) &&
        (selectedFrequency.length === 0 ||
         selectedFrequency.includes(item.Frequency)) &&
        (selectedRiskArea.length === 0 ||
         selectedRiskArea.includes(item["Risk Area"])) &&
        (selectedDates.length === 0 ||
         selectedDates.includes(String(item["Current Reporting Date"])))
    );
});

        setFilteredData(result);
    }, [
        selectedCriticality,
        selectedFrequency,
        selectedRiskArea,
        selectedDates,
        excelData
    ]);
    /* ------------------ RISK BAR ------------------ */

    const formatValue = (raw) => {
        if (!raw) return "";

        // If already contains letters like mm, bn → return as-is
        if (typeof raw === "string" && /[a-zA-Z]/.test(raw)) {
            return raw;
        }

        // Otherwise treat as decimal percentage
        const num = parseFloat(raw);
        if (isNaN(num)) return raw;

        return (num * 100).toFixed(2) + "%";
    };

    const MultiSelectDropdown = ({
        label,
        options,
        selectedValues,
        setSelectedValues,
        formatOption
    }) => {
        const [open, setOpen] = useState(false);
        const dropdownRef = React.useRef(null);

        // Close when clicking outside
        useEffect(() => {
            const handleClickOutside = (event) => {
                if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                    setOpen(false);
                }
            };
            document.addEventListener("mousedown", handleClickOutside);
            return () => document.removeEventListener("mousedown", handleClickOutside);
        }, []);

        const toggleValue = (value) => {

    if (selectedValues === null) {
        setSelectedValues([value]);
        return;
    }

    if (selectedValues.includes(value)) {
        setSelectedValues(selectedValues.filter(v => v !== value));
    } else {
        setSelectedValues([...selectedValues, value]);
    }
};

        const isAllSelected =
    selectedValues !== null &&
    (selectedValues.length === 0 || selectedValues.length === options.length);

        return (
            <div
                ref={dropdownRef}
                style={{
                    position: "relative",
                    width: "180px",
fontSize: "12px"
                }}
            >
                {/* HEADER */}
                <div
                    onClick={() => setOpen(!open)}
                    style={{
    border: open ? "1px solid #2b6cb0" : "1px solid #cbd5e1",
    padding: "5px 8px",
    cursor: "pointer",
    background: "#ffffff",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: "6px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
    fontWeight: 500,
    transition: "all 0.2s ease",
    fontSize: "12px"
}}
                >
                    <span>
    {selectedValues === null
        ? "None"
        : isAllSelected
        ? label
        : `${selectedValues.length} selected`}
</span>
                    <span style={{ fontSize: "12px", color: "#64748b" }}>▼</span>
                </div>

                {/* DROPDOWN */}
                {open && (
                    <div
                        style={{
    position: "absolute",
    top: "105%",
    left: 0,
    width: "100%",
    border: "1px solid #cbd5e1",
    background: "#ffffff",
    maxHeight: "200px",
    overflowY: "auto",
    borderRadius: "6px",
    boxShadow: "0 8px 20px rgba(0,0,0,0.12)",
    zIndex: 999
}}
                    >
                        {/* ALL OPTION */}
                        <div
                            style={{
    padding: "8px 10px",
    borderBottom: "1px solid #e5e7eb",
    background: "#f8fafc",
    fontWeight: 500
}}
                        >
                            <label style={{ cursor: "pointer" }}>
                                <input
                                    type="checkbox"
                                    checked={isAllSelected}
                                    onChange={() => {
    if (isAllSelected) {
        setSelectedValues(null); // none selected
    } else {
        setSelectedValues(options.map(opt => String(opt))); // all selected
    }
}}
                                />{" "}
                                (All)
                            </label>
                        </div>

                        {/* OPTIONS */}
                        {options.map((opt, i) => (
                            <div
                                key={i}
                                style={{
    padding: "7px 10px",
    cursor: "pointer"
}}
                            >
                                <label style={{ cursor: "pointer" }}>
                                    <input
                                        type="checkbox"
                                        checked={
    selectedValues !== null &&
    Array.isArray(selectedValues) &&
    (
        selectedValues.length === 0 ||
        selectedValues.includes(String(opt))
    )
}
                                        onChange={() => toggleValue(String(opt))}
                                    />{" "}
                                    {formatOption ? formatOption(opt) : opt}
                                </label>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        );
    };

    const BarRow = ({ item }) => {
        const value = formatValue(item["Current Value"]);

        return (
            <div
                style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}
                onMouseEnter={(e) =>
                    setTooltip({
                        show: true,
                        x: e.clientX,
                        y: e.clientY,
                        data: item
                    })
                }
                onMouseLeave={() =>
                    setTooltip({ show: false, x: 0, y: 0, data: null })
                }
            >
                <div style={{ width: "90px", fontSize: "11px" }}>
                    {formatExcelDate(item["Current Reporting Date"])}
                </div>

                <div
                    style={{
                        display: "flex",
                        flex: 1,
                        height: "20px",
                        cursor: "pointer"
                    }}
                >
                    <div
                        style={{
                            flex: 1,
                            backgroundColor: "#16a34a",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "11px",
                            color: "white"
                        }}
                    >
                        {item["Current Status"] === "Green" ? `${value}` : ""}
                    </div>

                    <div
                        style={{
                            flex: 1,
                            backgroundColor: "#facc15",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "11px"
                        }}
                    >
                        {item["Current Status"] === "Amber" ? `${value}` : ""}
                    </div>

                    <div
                        style={{
                            flex: 1,
                            backgroundColor: "#dc2626",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "11px",
                            color: "white"
                        }}
                    >
                        {item["Current Status"] === "Red" ? `${value}` : ""}
                    </div>
                </div>
            </div>
        );
    };

    const sectionStyle = {
        border: "1px solid #2b6cb0",
        marginBottom: "20px",
        padding: "15px"
    };

    const sectionTitle = {
        color: "#2b6cb0",
        marginBottom: "15px",
        fontWeight: "600"
    };

    const indicatorBox = {
        flex: "1 1 calc(33.33% - 20px)",   // 3 per row
        minWidth: "250px"
    };


    const getFilteredBaseData = () => {

    if (
        selectedCriticality === null ||
        selectedFrequency === null ||
        selectedRiskArea === null
    ) {
        return [];
    }

    return excelData.filter(item =>
        (selectedCriticality.length === 0 ||
         selectedCriticality.includes(item.Criticality)) &&
        (selectedFrequency.length === 0 ||
         selectedFrequency.includes(item.Frequency)) &&
        (selectedRiskArea.length === 0 ||
         selectedRiskArea.includes(item["Risk Area"]))
    );
};

    const criticalityOptions = [
  ...new Set(
    excelData
      .filter(item =>
        (selectedFrequency === null ||
 selectedFrequency.length === 0 ||
 selectedFrequency.includes(item.Frequency)) &&
(selectedRiskArea === null ||
 selectedRiskArea.length === 0 ||
 selectedRiskArea.includes(item["Risk Area"])) &&
(selectedDates === null ||
 selectedDates.length === 0 ||
 selectedDates.includes(String(item["Current Reporting Date"])))
        
      )
      .map(i => i.Criticality)
  )
];

const frequencyOptions = [
  ...new Set(
    (excelData || [])
      .filter(item =>
        (!selectedCriticality || selectedCriticality.length === 0 || selectedCriticality.includes(item.Criticality)) &&
        (!selectedRiskArea || selectedRiskArea.length === 0 || selectedRiskArea.includes(item["Risk Area"])) &&
        (!selectedDates || selectedDates.length === 0 || selectedDates.includes(String(item["Current Reporting Date"])))
      )
      .map(i => i.Frequency)
  )
];

const riskAreaOptions = [
  ...new Set(
    excelData
      .filter(item =>
        (selectedCriticality === null ||
 selectedCriticality.length === 0 ||
 selectedCriticality.includes(item.Criticality)) &&
(selectedFrequency === null ||
 selectedFrequency.length === 0 ||
 selectedFrequency.includes(item.Frequency)) &&
(selectedDates === null ||
 selectedDates.length === 0 ||
 selectedDates.includes(String(item["Current Reporting Date"])))

      )
      .map(i => i["Risk Area"])
  )
];

const dateOptions = [
  ...new Set(
    excelData
      .filter(item =>
(selectedCriticality === null ||
 selectedCriticality.length === 0 ||
 selectedCriticality.includes(item.Criticality)) &&
(selectedRiskArea === null ||
 selectedRiskArea.length === 0 ||
 selectedRiskArea.includes(item["Risk Area"])) &&
(selectedDates === null ||
 selectedDates.length === 0 ||
 selectedDates.includes(String(item["Current Reporting Date"])))
      )
      .map(i => i["Current Reporting Date"])
  )
];





    return (
        <div className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}>
            <Header />
            <Navigation />
            <main className="flex-grow-1 container-fluid d-flex">
                <div className={`${styles.mainContainer} w-100 d-flex`}>
                    <div className="container-fluid d-flex">

                        <div
                            className={`card w-100 d-flex flex-column ${styles.cardBorder} ${styles.card}`}
                        // style={{ height: "calc(100vh - 140px)" }}   // adjust 140px based on header+nav height
                        >

                            {/* Card Header (Static) */}
                            <div className="card-header bg-transparent text-dark ">
                                <h5 className="mb-0">Risk Appetite Monitoring</h5>
                            </div>

                            <div
  style={{
    display: "flex",
    gap: "12px",
    marginBottom: "6px",
    marginLeft: "16px",
    marginTop: "6px"
    // justifyContent: "flex-end"
  }}
>
                                <MultiSelectDropdown
                                    label="Criticality"
                                    options={criticalityOptions}
                                    selectedValues={selectedCriticality}
                                    setSelectedValues={setSelectedCriticality}
                                />

                                <MultiSelectDropdown
                                    label="Frequency"
                                    options={frequencyOptions}
                                    selectedValues={selectedFrequency}
                                    setSelectedValues={setSelectedFrequency}
                                />

                                <MultiSelectDropdown
                                    label="Risk Area"
                                    options={riskAreaOptions}
                                    selectedValues={selectedRiskArea}
                                    setSelectedValues={setSelectedRiskArea}
                                />

                                <MultiSelectDropdown
                                    label="Reporting Date"
                                    options={dateOptions}
                                    selectedValues={selectedDates}
                                    setSelectedValues={setSelectedDates}
                                    formatOption={formatExcelDate}
                                />

                            </div>
                            {/* Card Body (Scrollable) */}
                            <div className="table-on-homepage-only">

                                {/* <div className={`tableWrapper ${tableStyles.tableWrapper}`}
                                    style={{ maxHeight: "340px",border: "1px solid #2b6cb0" }}> */}
                                <div
                                    className={`tableWrapper ${tableStyles.tableWrapper}`}
                                    style={{
                                        flex: 1,
                                        maxHeight: "calc(100vh - 250px)",
                                        border: "none",
                                        overflowY: "auto"
                                    }}
                                >

                                    <div className="custom-table-with-status-colors w-100 position-relative">
                                        <div
                                            className="card-body"
                                            style={{
                                                overflowY: "auto",
                                                flex: 1
                                            }}
                                        >

                                            {/* ---------------- FILTERS ---------------- */}


                                            {/* ---------------- GRAPH SECTION ---------------- */}
                                            {/* ---------------- GROUPED GRAPH SECTION ---------------- */}
                                            {filteredData.length === 0 ? (
                                                <p>No Data Found</p>
                                            ) : (
                                                Object.entries(
                                                    filteredData.reduce((acc, item) => {
                                                        const area = item["Risk Area"] || "Others";
                                                        const indicator = item["Risk Indicator"];

                                                        if (!acc[area]) acc[area] = {};
                                                        if (!acc[area][indicator]) acc[area][indicator] = [];

                                                        acc[area][indicator].push(item);
                                                        return acc;
                                                    }, {})
                                                ).map(([riskArea, indicators]) => (
                                                    <div key={riskArea} style={sectionStyle}>
                                                        <h6 style={sectionTitle}>{riskArea}</h6>

                                                        <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
                                                            {Object.entries(indicators).map(([indicatorName, items], idx) => (
                                                                <div key={idx} style={indicatorBox}>
                                                                    <div style={{ fontWeight: 600, marginBottom: "10px" }}>
                                                                        {indicatorName}
                                                                    </div>

                                                                    {items.map((item, i) => (
                                                                        <BarRow key={i} item={item} />
                                                                    ))}

                                                                    {/* THRESHOLD ONLY ONCE */}
                                                                    <div
                                                                        style={{
                                                                            display: "flex",
                                                                            marginLeft: "90px",
                                                                            fontSize: "10px",
                                                                            marginTop: "4px"
                                                                        }}
                                                                    >
                                                                        <div style={{ flex: 1, textAlign: "center" }}>
                                                                            {items[0]["Green"]}
                                                                        </div>

                                                                        <div style={{ flex: 1, textAlign: "center" }}>
                                                                            {items[0]["Amber"]}
                                                                        </div>

                                                                        <div style={{ flex: 1, textAlign: "center" }}>
                                                                            {items[0]["Red"]}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                        {tooltip.show && tooltip.data && (
                                                            <div
                                                                style={{
                                                                    position: "fixed",
                                                                    top: tooltip.y + 12,
                                                                    left: tooltip.x + 12,
                                                                    background: "#ffffff",
                                                                    borderRadius: "8px",
                                                                    padding: "12px 14px",
                                                                    fontSize: "13px",
                                                                    // boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
                                                                    border: "1px solid #e5e7eb",
                                                                    minWidth: "200px",
                                                                    zIndex: 999
                                                                }}
                                                            >
                                                                {/* Indicator Title */}
                                                                <div
                                                                    style={{
                                                                        fontWeight: "600",
                                                                        fontSize: "14px",
                                                                        marginBottom: "8px",
                                                                        color: "#1f2937"
                                                                    }}
                                                                >
                                                                    {tooltip.data["Risk Indicator"]}
                                                                </div>

                                                                {/* Value Row */}
                                                                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "4px" }}>
                                                                    <span style={{ color: "#6b7280" }}>Value</span>
                                                                    <span style={{ fontWeight: "500" }}>
                                                                        {formatValue(tooltip.data["Current Value"])}
                                                                    </span>
                                                                </div>

                                                                {/* Date Row */}
                                                                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "4px" }}>
                                                                    <span style={{ color: "#6b7280" }}>Date</span>
                                                                    <span>
                                                                        {formatExcelDate(tooltip.data["Current Reporting Date"])}
                                                                    </span>
                                                                </div>

                                                                {/* Status Row */}
                                                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                                    <span style={{ color: "#6b7280" }}>Status</span>

                                                                    <span
                                                                        style={{
                                                                            padding: "2px 8px",
                                                                            borderRadius: "10px",
                                                                            fontSize: "11px",
                                                                            fontWeight: "600",
                                                                            background:
                                                                                tooltip.data["Current Status"] === "Green"
                                                                                    ? "#dcfce7"
                                                                                    : tooltip.data["Current Status"] === "Amber"
                                                                                        ? "#fef3c7"
                                                                                        : "#fee2e2",
                                                                            color:
                                                                                tooltip.data["Current Status"] === "Green"
                                                                                    ? "#15803d"
                                                                                    : tooltip.data["Current Status"] === "Amber"
                                                                                        ? "#b45309"
                                                                                        : "#b91c1c"
                                                                        }}
                                                                    >
                                                                        {tooltip.data["Current Status"]}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                ))
                                            )}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </main>
            <Footer />
            {/* </div> */}
        </div>
    );
}

export default GapsyTableauReport;